import { render, staticRenderFns } from "./SendConfirmCode.vue?vue&type=template&id=5d3a4a41&"
import script from "./SendConfirmCode.vue?vue&type=script&lang=js&"
export * from "./SendConfirmCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports